const BUTTON_HEIGHT_PX = 44;

// Used in the sidebar itself and in the placing of the central grid
export const SIDEBAR_PADDING_PX = 5;
export const SIDEBAR_CLOSED_PX = BUTTON_HEIGHT_PX + SIDEBAR_PADDING_PX * 2;
export const SIDEBAR_OPEN_PX = 240;

const CELL_WIDTH_REM = 23;

export const SIZES = {
  button: BUTTON_HEIGHT_PX + "px", // 11
  small_button: "32px", // 8

  table_cell_xxxs: CELL_WIDTH_REM / 6 + "rem",
  table_cell_xxs: CELL_WIDTH_REM / 4 + "rem",
  table_cell_xs: CELL_WIDTH_REM / 2 + "rem",
  table_cell_sm: CELL_WIDTH_REM / 1.5 + "rem",
  table_cell: CELL_WIDTH_REM + "rem",
  table_cell_l: CELL_WIDTH_REM * 1.5 + "rem",
  table_cell_xl: CELL_WIDTH_REM * 2 + "rem",
  table_cell_xxl: CELL_WIDTH_REM * 4 + "rem",
  table_cell_xxxl: CELL_WIDTH_REM * 6 + "rem",

  // Small sizes:
  0: 0,
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  6: "24px",
  8: "32px",
  11: "44px",
  16: "64px",
  24: "96px",
  32: "128px",
  36: "144px",
  44: "176px",
  52: "208px",
  56: "224px",

  // Large sizes
  "3xs": "224px",
  "2xs": "256px",
  xs: "320px",
  sm: "384px",
  md: "448px",
  lg: "512px",
  xl: "576px",
  "2xl": "672px",
  "3xl": "768px",
  "4xl": "896px",
  "5xl": "1024px",
  "6xl": "1152px",
  "7xl": "1280px",
  "8xl": "1440px",

  // Fractions
  "1/2": "50%",
  "1/3": "33.333333%",
  "2/3": "66.666667%",
  "1/4": "25%",
  "3/4": "75%",
  "1/5": "20%",
  "2/5": "40%",
  "3/5": "60%",
  "4/5": "80%",
  "1/6": "16.666667%",
  "2/6": "33.333333%",
  "3/6": "50%",
  "4/6": "66.666667%",
  "5/6": "83.333333%",
  "1/12": "8.333333%",
  "2/12": "16.666667%",
  "3/12": "25%",
  "4/12": "33.333333%",
  "5/12": "41.666667%",
  "6/12": "50%",
  "7/12": "58.333333%",
  "8/12": "66.666667%",
  "9/12": "75%",
  "10/12": "83.333333%",
  "11/12": "91.666667%",

  // Special sizes
  max: "max-content",
  min: "min-content",
  fit: "fit-content",
  prose: "85ch",
  full: "100%",
  dvh: "100dvh",
  svh: "100svh",
  lvh: "100lvh",
  dvw: "100dvw",
  svw: "100svw",
  lvw: "100lvw",
  vw: "100vw",
  vh: "100vh",
  auto: "auto",

  // Breakpoints
  "breakpoint-sm": "480px",
  "breakpoint-md": "768px",
  "breakpoint-lg": "1024px",
  "breakpoint-xl": "1280px",
  "breakpoint-2xl": "1536px",
};

export type SizingKey = keyof typeof SIZES;
